import Api from "@/services/Api";

export default {
  async roleAudit(typeId) {
    const response = await Api(true).post("/role/audit", { type_id: typeId });
    return response.data;
  },

  async userAudit(userId) {
    const response = await Api(true).post("/user/audit", { user_id: userId });
    return response.data;
  },

  async catalog() {
    const response = await Api(true).post("permissions/list");
    return response.data;
  },

  async getRolePermissions(typeId) {
    const response = await Api(true).post("/get/user/type/permissions", { type_id: typeId });
    return response.data;
  },
};
